<template>
    <div id="calendar">
        <calendar-filters @filtered="filterData" :updating="updating"></calendar-filters>
        <calendar-view :filters="filters" @updating="updating = true" @loaded="updating = false"></calendar-view>
        <div class="calendar-overlay" :class="updating ? 'opacity-100 fixed z-50 w-full h-full' : 'opacity-0 absolute z-0 w-0 h-0'">
            <div class="h-full w-full flex items-center justify-center">
                <md-progress-spinner class="md-white" md-mode="indeterminate"
                                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
            </div>
        </div>
        <md-drawer class="drawer-form" md-right md-fixed :md-active.sync="panel.show" @md-closed="closePanel">
            <panel-edit-day v-if="panel.type === 'edit-day'"
                            :day="panel.data.day"
                            :plannings="panel.data.plannings"
                            :isConflict="panel.data.isConflict"
                            :technician="panel.data.technician"
                            @close="closePanel">
            </panel-edit-day>
            <panel-add-element v-if="panel.type === 'add-element'"
                               :day="panel.data.day"
                               :technician="panel.data.technician"
                               @close="closePanel">
            </panel-add-element>
            <panel-add-absence v-if="panel.type === 'add-absence'"
                               :day="panel.data.day"
                               :technician="panel.data.technician"
                               @close="closePanel">
            </panel-add-absence>
            <panel-transfer-interventions v-if="panel.type === 'transfer-interventions'"
                                          :day="panel.data.day"
                                          :plannings="panel.data.plannings"
                                          :isConflict="panel.data.isConflict"
                                          :technician="panel.data.technician"
                                          @close="closePanel">
            </panel-transfer-interventions>
        </md-drawer>
    </div>
</template>

<script>
import CalendarFilters from "@/pages/Planning/Calendar/components/CalendarFilters";
import CalendarView from "@/pages/Planning/Calendar/components/CalendarView";
import PanelEditDay from "@/pages/Planning/Calendar/components/calendar/panel/PanelEditDay";
import PanelAddElement from "@/pages/Planning/Calendar/components/calendar/panel/PanelAddElement";
import PanelAddAbsence from "@/pages/Planning/Calendar/components/calendar/panel/PanelAddAbsence";
import PanelTransferInterventions from "@/pages/Planning/Calendar/components/calendar/panel/PanelTransferInterventions";

export default {
    name: "Calendar",
    components: {
        CalendarFilters, CalendarView, PanelEditDay, PanelAddElement, PanelAddAbsence, PanelTransferInterventions
    },
    data() {
        return {
            filters: {
                date: {
                    month: null,
                    year: null,
                },
                technicians: []
            },
            updating: true,
            panel: {
                show: false,
                type: null,
                data: null
            },
        }
    },
    methods: {
        filterData(e) {
            this.updating = true
            this.filters = _.cloneDeep(e)
        },
        closePanel() {
            this.panel = {
                show: false,
                type: null,
                data: null
            }
        }
    },
    mounted() {
        bus.$emit('minimise-sidebar')
        this.$store.dispatch('calendarTransfer/clearInterventions')
    },
    created() {
        bus.$on('open-calendar-panel', (event) => {
            this.panel = { show: true, type: event.type, data: event.data }
        })
    },
}
</script>

<style scoped lang="scss">

</style>
